import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import * as styles from './GlobalNav.module.styl';
import Button from '../Button';
import MenuItem from './MenuItem';
import SubMenu from './SubMenu';
import MobileMenu from './MobileMenu';
import useMainMenu from '../../utils/useMainMenu';
import useSiteSettings from '../../utils/useSiteSettings';
import { FiMenu, FiX } from 'react-icons/fi';

const Nav = ({ fixed, invert, isTry }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState('');
  const { menuItems } = useMainMenu();

  const { register_button_text_paperform } = useSiteSettings();
  const registerText = register_button_text_paperform || 'Try Paperform Free';

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
  }, [menuOpen]);

  return (
    <>
      <div
        className={classnames(
          styles.wrapper,
          fixed && styles.fixed,
          invert && styles.inverted,
          menuOpen ? styles.wrapperMenuOpen : null,
        )}
      >
        <div className={classnames(styles.content, 'px-8')}>
          <Link to="/" className={styles.logo} style={{ position: 'relative' }}>
            <img
              alt="Paperform logo"
              className={`transition-all duration-700 opacity-100 top-0`}
              src={
                invert
                  ? '/website/logo-v3/Paperform_Master_White.png'
                  : '/website/logo-v3/Paperform_Master_Black.png'
              }
            />
          </Link>

          <div className={styles.links}>
            {menuItems.map((item) => (
              <MenuItem
                item={item}
                key={item.title}
                isActive={activeSubMenu === item.title}
                setActiveSubMenu={setActiveSubMenu}
              />
            ))}
          </div>
          <div className={styles.mobileMenuButton}>
            <span onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <FiX /> : <FiMenu />}
            </span>
          </div>
          <div className={styles.menuButtons}>
            <Button
              midnight={!invert}
              black={invert}
              solid={invert}
              href="/dashboard"
            >
              Sign in
            </Button>
            {isTry ? (
              <Button yellow solid className="ml-3" href="/try">
                Try without signing up
              </Button>
            ) : (
              <Button yellow solid className="ml-3" href={'/register'}>
                {registerText}
              </Button>
            )}
          </div>
          <MobileMenu
            menu={menuItems}
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            invert={invert}
            activeSubMenu={activeSubMenu}
            setActiveSubMenu={setActiveSubMenu}
            registerUrl={'/register'}
            registerText={registerText}
          />
        </div>
      </div>
      {menuItems.map((item) => (
        <SubMenu
          key={item.title}
          isOpen={activeSubMenu === item.title && item.title != ''}
          title={item.title}
          subMenu={item.sub_menu}
          integrations={item.integrations}
          helpMenu={item.help_menu}
          featuredItem={item.featured_item}
          setActiveSubMenu={setActiveSubMenu}
        />
      ))}
    </>
  );
};

export default Nav;
